/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/**
 * The possible confusion types.
 */
export enum ConfusionType {
    TruePositive = 1,
    TrueNegative = 2,
    FalsePositive = 3,
    FalseNegative = 4
}
